import { module } from 'modujs';

export default class Dropdown extends module {

    static get settings() {
        return {
            VISIBLE_CLASS: 'is-open'
        }
    }

    constructor(m) {
        super(m);

        this.events = {
            click: {
                'button': 'toggle'
            },
        }
    }

    init() {

        this.isOpen = false
        this.onDOMClick = () => {}
    }

    toggle() {
        if(this.isOpen) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {

        if(this.isOpen) {
            return
        }

        this.el.classList.add(Dropdown.settings.VISIBLE_CLASS)
        this.isOpen = true

        // Close on click outside of element
        document.addEventListener('click', this.onDOMClick = e => {
            const isClickInsideElement = this.el.contains(event.target);
            if (!isClickInsideElement) {
                this.close()
            }
        });
    }

    close() {

        if(!this.isOpen) {
            return
        }

        this.el.classList.remove(Dropdown.settings.VISIBLE_CLASS)
        this.isOpen = false
        document.removeEventListener('click', this.onDOMClick)
    }

    destroy() {
        document.removeEventListener('click', this.onDOMClick)
    }
}
